import axios from "axios";
import Router from "next/router";
import { destroyCookie, parseCookies } from 'nookies';

export function getAPIClient(context?: any) {
    const { 'rifaAuthToken': token } = parseCookies(context);

    const api = axios.create({
        baseURL: process.env.NEXT_PUBLIC_API,
    })

    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    api.interceptors.response.use(
        response => response,
        error => {
            if (error.response && error.response.status === 401) {
                destroyCookie(context, 'rifaAuthToken', {
                    domain: process.env.NEXT_PUBLIC_DOMAIN,
                    path: "/"
                });
                Router.push('/login');
            }
            return Promise.reject(error);
        }
    );

    return api;
}